import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["initialState", "matchContent", "noMatchContent"]
  static values = {
    matchOn: { type: Array, default: [] }
  }

  connect() {
    if (this.hasMatchOnValue && this.hasInitialStateTarget) {
      this.toggle({ target: this.initialStateTarget })
    }
  }

  match() {
    this.matchContentTargets.forEach(el => {
      el.disabled = false
      el.classList.remove("hidden")
    })
    this.noMatchContentTargets.forEach(el => {
      el.disabled = true
      el.classList.add("hidden")
    })
  }

  noMatch() {
    this.matchContentTargets.forEach(el => {
      el.disabled = true
      el.classList.add("hidden")
    })
    this.noMatchContentTargets.forEach(el => {
      el.disabled = false
      el.classList.remove("hidden")
    })
  }

  toggle(e) {
    let match
    if (e.target.type === "checkbox") {
      match = e.target.checked
    } else {
      match = this.matchOnValue.includes(e.target.value)
    }
    match ? this.match() : this.noMatch()
  }
}
